import toWebpImage from '@src/utils/to-webp-image';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

const pageLocalesData = getPageLocalesData();
const LocalesData = pageLocalesData.mechaUnit;
const narukamiData = LocalesData.narukami;
const lang = getLanguageByPath();

/**
 *  特装机甲数据
 */
export const mechaData = {
  mechaName: toWebpImage(`${require('./images/' + lang + '/warrior-name.png')}`),
  mechaImg: toWebpImage(require('./images/structure.png')),
  driverImg: toWebpImage(require('./images/per.png')),
  iconBadge: toWebpImage(require('./images/icon-badge.png')),
  maLogo: toWebpImage(require('./images/ma-logo.png')),
  btnBack: toWebpImage(require('./images/' + lang + '/btn-back.png')),
  driverStoryTitle: require('./images/' + lang + '/driver-story-title.png'),
  cvTab: [toWebpImage(require('./images/checked1.png')), toWebpImage(require('./images/checked2.png')), toWebpImage(require('./images/checked3.png'))],
  audioScreen: require('./images/audio-screen.png'),
  mechaInfoTitle: require('./images/' + lang + '/mecha-info-title.png'),
  manufacturerTitle: require('./images/' + lang + '/manufacturer-title.png'),
  basicInfoTitle: LocalesData.basicInfoTitle,
  driverVoiceTitle: LocalesData.driverVoiceTitle,
  mechaStorySubTitle: LocalesData.mechaStorySubTitle,
  roleExperSubTitle: narukamiData.roleExperSubTitle,
  driverName: narukamiData.driverName,
  driverType: narukamiData.driverType,
  driversSex: narukamiData.driversSex,
  driversBirthplace: narukamiData.driversBirthplace,
  driversStructure: narukamiData.driversStructure,
  driversRoleExperText: narukamiData.driversRoleExperText,
  mechaInfoType: narukamiData.mechaInfoType,
  mechaInfoNums: narukamiData.mechaInfoNums,
  mechaInfoHeadHigh: narukamiData.mechaInfoHeadHigh,
  mechaInfoEmptyWeight: narukamiData.mechaInfoEmptyWeight,
  mechaInfoTotal: narukamiData.mechaInfoTotal,
  mechaInfoStory: narukamiData.mechaInfoStory,
  manufacturerGruopCh: narukamiData.manufacturerGruopCh,
  cvCH: narukamiData.cvCH,
  cvEN: narukamiData.cvEN,
  cvJA: narukamiData.cvJA,
  zhCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202508/1754993909484_1-Vox_Pilot_Get_Elite_KanonKamiya.wav',
      title: narukamiData.voice.title1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202508/1754993909484_2-Vox_Pilot_Entrance_Elite_KanonKamiya_a.wav',
      title: narukamiData.voice.title2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202508/1754993909484_3-Vox_Pilot_MVP_Elite_KanonKamiya_a.wav',
      title: narukamiData.voice.title3,
      isPlay: false
    }
  ],
  enCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202508/1754993821945_1-Vox_Pilot_Get_Elite_KanonKamiya.wav',
      title: narukamiData.voice.title1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202508/1754993821945_2-Vox_Pilot_Entrance_Elite_KanonKamiya_a.wav',
      title: narukamiData.voice.title2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202508/1754993821945_3-Vox_Pilot_MVP_Elite_KanonKamiya_a.wav',
      title: narukamiData.voice.title3,
      isPlay: false
    }
  ],
  jaCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202508/1754993853187_1-Vox_Pilot_Get_Elite_KanonKamiya.wav',
      title: narukamiData.voice.title1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202508/1754993853187_2-Vox_Pilot_Entrance_Elite_KanonKamiya_a.wav',
      title: narukamiData.voice.title2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202508/1754993884173_3-Vox_Pilot_MVP_Elite_KanonKamiya_a.wav',
      title: narukamiData.voice.title3,
      isPlay: false
    }
  ]
};
